import Loader from "components/loader/Loader";
import { identity } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const FinancialSettingPage = () => {


  const options = [
    {
      id: "account-billing-types",
      label: "Account Billing Types",
      url: "/financial-setting/account-billing-types/view",
    },
    { id: "bank-accounts", label: "Bank Accounts", url: "/financial-setting/bank-accounts/view" },
    // { id: "charge-types", label: "Charge Types", url: "/charge-types/view" },
    {
      id: "ledger-accounts",
      label: "Ledger Accounts",
      url: "/financial-setting/ledger-accounts/view",
    },
    { id: "payment-types", label: "Payment Types", url: "/financial-setting/payment-types/view" },
    {
      id: "reversal-types",
      label: "Reversal Types",
      url: "/financial-setting/reversal-types/view",
    },
    {
      id: "provider-info",
      label: "Gateway Settings",
      url: "/financial-setting/provider-info/view",
    },
    {
      id: "software-integration",
      label: "Financial Software Integration",
      url: "/financial-setting/software-integration/view",
    },
    {
      id: "accounts-receivable",
      label: "Accounts Receivable",
      url: "/financial-setting/accounts-receivable/view",
    },
    {
      id: "tax-id",
      label: "Tax ID",
      url: "/financial-setting/accounts-tax-id",
    },
  ];
  return  (
    <div className="col-md-4 setting-menu-sider-main">
      {options.map((item) => (
        <>
          <Link to={item.url} key={item.id}>
            <div className="p-5 bg-white text-dark setting-menu-sider">
              <div>
                <h3>{item.label}</h3>
              </div>
              <div className="arrow-icon-menu">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </div>
            </div>
          </Link>
        </>
      ))}
    </div>
  );
};

export default FinancialSettingPage;
